import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { JVInput } from "../../../shared/JVInput";
import { JVDate } from "../../../shared/JVDate";
import { IPurchaseOrder } from '../../../models/PurchaseOrder';
import { useState } from 'react';
import { Fetch } from '../../../shared/Fetch';
import { JVInputMask } from '../../../shared/JVInputMask';
import { Button } from 'primereact/button';

interface Iprops {
    po: IPurchaseOrder,
    toast: any,
    activeIndex: number,
    setActiveIndex: (index: number) => void,
    setNeedtoReload: (reload: boolean) => void
}
const schema = yup.object({
    project_Client_Name: yup.string().required("Client is required").typeError("Client is required"),
    project_Name: yup.string().required("Project Name is required").typeError("Project Name is required"),
    pM_Name: yup.string().required("PM Name is required").typeError("PM Name is required"),
    pM_Email: yup.string().email("Invalid Email ID").required("Email ID is required").typeError("Email ID is required"),
    phone: yup.string().required("Phone No is required").typeError("Phone No is required"),
    ext: yup.string().nullable(),
    pO_Date: yup.date().required("PO Date is required").typeError("PO Date is required"),
    project_Start_Date: yup.date().required("Start Date is required").typeError("Start Date is required"),
    project_End_Date: yup.date().required("End Date is required").typeError("End Date is required"),
});

export const ProjectInformation = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, formState: { errors } } = useForm<IPurchaseOrder>({
        resolver: yupResolver(schema),
        defaultValues: {
            project_Client_Name: props.po.project_Client_Name,
            project_Name: props.po.project_Name,
            pM_Name: props.po.pM_Name,
            pM_Email: props.po.pM_Email,
            phone: props.po.phone,
            ext: props.po.ext,
            pO_Date: props.po.pO_Date ? new Date(props.po.pO_Date) : undefined,
            project_Start_Date: props.po.project_Start_Date ? new Date(props.po.project_Start_Date) : undefined,
            project_End_Date: props.po.project_End_Date ? new Date(props.po.project_End_Date) : undefined
        },
        shouldFocusError: false
    });

    const saveToDB = async (body: IPurchaseOrder) => {
        setLoading(true);
        body.pO_ID = props.po.pO_ID;
        const response = await Fetch("vwPODetails/details", "POST", body, `tb=${4}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Saved Successfully" });
            props.setActiveIndex(props.activeIndex + 1);
            props.setNeedtoReload(true);
        }
        setLoading(false);
    }
    function onSubmit(data: IPurchaseOrder) {
        saveToDB(data);
    }

    return (
        <div className='w-11 m-auto mt-2'>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVInput required column={3} label="Client" control={control} name="project_Client_Name" error={errors.project_Client_Name?.message} />
                <JVInput required column={3} label="Project Name" control={control} name="project_Name" error={errors.project_Name?.message} />
                <JVInput required column={3} label="PM Name" control={control} name="pM_Name" error={errors.pM_Name?.message} />

                <JVInput required column={3} label="Email ID" control={control} name="pM_Email" error={errors.pM_Email?.message} />
                <JVInputMask required mask="(999) 999-9999" column={3} label="Phone No" control={control} name="phone" error={errors.phone?.message} />
                <JVInput column={3} label="Ext" control={control} name="ext" error={errors.ext?.message} />

                <JVDate required column={3} label="PO Date" control={control} name="pO_Date" error={errors.pO_Date?.message} />
                <JVDate required column={3} label="Start Date" control={control} name="project_Start_Date" error={errors.project_Start_Date?.message} />
                <JVDate required column={3} label="Exp. End Date" control={control} name="project_End_Date" error={errors.project_End_Date?.message} />
                <div className="field col-12 md:col-4">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} type="submit" label='SAVE & NEXT'></Button>
                </div>
            </form>
        </div>
    );
}